import React from "react";
import { TableCellProps } from "@mui/material/TableCell";
import { TableCell } from "../../UI/TableCell";

export interface IProps extends TableCellProps {
  colSpan?: number;
  className?: string;
  isDragOccurring: boolean;
}

export interface ISnapshotProps {
  width: number;
  height: number;
}

/**
 * We used this component only for DraggableRow
 * to fix the cell size while dragging
 */
class DraggableTableCell extends React.PureComponent<IProps> {
  public tableCellRef: any;

  public getSnapshotBeforeUpdate(prevProps: IProps): ISnapshotProps | null {
    if (!this.tableCellRef) {
      return null;
    }

    const isDragStarting: boolean = this.props.isDragOccurring && !prevProps.isDragOccurring;

    if (!isDragStarting) {
      return null;
    }

    const { width, height } = this.tableCellRef.getBoundingClientRect();

    return {
      width,
      height,
    };
  }

  public componentDidUpdate(prevProps: IProps, prevState: any, snapshot: ISnapshotProps) {
    if (!this.tableCellRef) {
      return;
    }

    if (snapshot) {
      if (+this.tableCellRef.style.width === snapshot.width) {
        return;
      }
      this.tableCellRef.style.width = `${snapshot.width}px`;
      this.tableCellRef.style.height = `${snapshot.height}px`;
      return;
    }

    if (this.props.isDragOccurring) {
      return;
    }

    // inline styles not applied
    if (this.tableCellRef.style.width === null) {
      return;
    }

    // no snapshot and drag is finished - clear the inline styles
    this.tableCellRef.style.removeProperty("height");
    this.tableCellRef.style.removeProperty("width");
  }

  public setTableCellRef = (ref: HTMLElement) => {
    this.tableCellRef = ref;
  };

  public render() {
    const { isDragOccurring, ...props } = this.props;

    return (
      <TableCell ref={this.setTableCellRef} {...props}>
        {this.props.children}
      </TableCell>
    );
  }
}

export { DraggableTableCell };
